import { Product } from './product';

export class OrderItem {
    orderItemId: string;
    product: Product;
    orderItemPrice: number;
    orderItemDiscount: number;
    productCode: string;
    productName: string;
    orderItemTotal: number;
    orderItemTax: number;
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/orderitem.ts